// Test IDs for the HR Enterprises / AURIX STUDIO home page.

export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const NAV = {
  root: 'nav-root',
  logoLink: 'nav-logo-link',
  linkHome: 'nav-link-home',
  linkDivisions: 'nav-link-divisions',
  linkServices: 'nav-link-services',
  linkPortfolio: 'nav-link-portfolio',
  linkLeadership: 'nav-link-leadership',
  linkContact: 'nav-link-contact',
  ctaConsult: 'nav-cta-consult',
  mobileToggle: 'nav-mobile-toggle',
  mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
  root: 'hero-section',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
  headline: 'hero-headline',
  scrollHint: 'hero-scroll-hint',
};

export const STATS = {
  root: 'stats-section',
  itemPrefix: 'stat-item',
};

export const DIVISIONS = {
  root: 'divisions-section',
  cardPrefix: 'division-card',
};

export const SERVICES = {
  root: 'services-section',
  cardPrefix: 'service-card',
};

export const LEADERSHIP = {
  root: 'leadership-section',
  cardPrefix: 'leader-card',
};

export const PORTFOLIO = {
  root: 'portfolio-section',
  cardPrefix: 'portfolio-card',
};

export const INDUSTRIES = {
  root: 'industries-section',
};

export const CONTACT = {
  root: 'contact-section',
  form: 'contact-form',
  name: 'contact-input-name',
  email: 'contact-input-email',
  phone: 'contact-input-phone',
  company: 'contact-input-company',
  service: 'contact-select-service',
  message: 'contact-input-message',
  submit: 'contact-submit-btn',
  whatsapp: 'contact-whatsapp-btn',
  phoneLink: 'contact-phone-link',
  emailLink: 'contact-email-link',
};

export const WHATSAPP = {
  float: 'whatsapp-float-btn',
};

export const FOOTER = {
  root: 'footer-root',
};
